export default __webpack_public_path__ + "static/media/instagramNew.9ee85458.svg";